import axios from 'axios';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  // ----- Exam Results -----
  async getAllExamResults(_obj, params) {
    const res = await axios.get(`api/exam-results/`, { params });
    return res.data;
  },

  async getExamResult(_obj, id) {
    const res = await axios.get(`api/exam-results/${id}/`);
    return res.data;
  },

  async createExamResult(_obj, data) {
    const res = await axios.post(`api/exam-results/`, data);
    return res.data;
  },

  async updateExamResult(_obj, { id, data }) {
    return axios.patch(`api/exam-results/${id}/`, data);
  },

  async deleteExamResult(_obj, id) {
    return axios.delete(`api/exam-results/${id}/`);
  },

  // ----- Result Documents -----
  async createResultDocument(_obj, data) {
    const res = await axios.post(`api/exam-results/documents/`, data);
    return res.data;
  },

  async deleteResultDocument(_obj, id) {
    return axios.delete(`api/exam-results/documents/${id}/`);
  },

  async getResultDocUploadPresignedUrl(_obj, data) {
    return (await axios.post(`api/exam-results/documents/upload-url/`, data)).data.data;
  },
};

export const examResult = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
